function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalculatorRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 15H17V5h8c1.103 0 2 .897 2 2v8zm0 10c0 1.103-.897 2-2 2h-8V17h10v8zM7 27c-1.103 0-2-.897-2-2v-8h10v10H7zM5 7c0-1.103.897-2 2-2h8v10H5V7zm20-4H7a4 4 0 00-4 4v18a4 4 0 004 4h18a4 4 0 004-4V7a4 4 0 00-4-4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 9h-2V7H9v2H7v2h2v2h2v-2h2V9zM19 11h6V9h-6v2zM19 21h6v-2h-6v2zM19 25h6v-2h-6v2zM11.563 19.045l-1.552 1.552-1.552-1.552-1.414 1.414 1.552 1.552-1.552 1.552 1.414 1.414 1.552-1.552 1.552 1.552 1.414-1.414-1.552-1.552 1.552-1.552-1.414-1.414z",
    fill: props.color
  }));
}

export default SvgIconCalculatorRexOutline;